var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "player"
  }, [_c('div', {
    class: 'controls animations ' + [!_vm.onGoingAnimation ? 'disabled' : '']
  }, [_c('player-button', {
    attrs: {
      "btnClassName": 'fas ' + [_vm.animationsOn ? 'fa-stop' : 'fa-play'],
      "on-click": _vm.handleToggleAnimations,
      "ariaLabel": 'Animations ' + [_vm.animationsOn ? 'On' : 'Off'],
      "ariaPressed": !_vm.animationsOn,
      "disabled": !_vm.onGoingAnimation
    }
  })], 1), _c('div', {
    class: 'controls caption-button ' + [_vm.showCaption ? '' : 'off']
  }, [_c('player-button', {
    attrs: {
      "on-click": _vm.handleToggleCaption,
      "show-icon": false,
      "show-text": true,
      "textClassName": 'caption-btn-text',
      "text": 'CC ' + [_vm.showCaption ? 'ON' : 'OFF'],
      "ariaLabel": 'Closed Captions',
      "ariaPressed": _vm.showCaption
    }
  })], 1), _vm.showCaption ? _c('div', {
    staticClass: "captions",
    style: _vm.cssVars
  }, [_c('span', {
    class: 'caption-text ' + [_vm.caption ? 'padded' : '']
  }, [_vm._v(_vm._s(_vm.caption))])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }